import type { RoleType } from '@/features/role/domain/enums/RoleType'

export class CancelOrderReasonsFilterEntity {
  role?: RoleType
}
